<template>
     <el-dialog :visible.sync="csWithdrawDialog" width="50%" top="8vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card>
            <el-table :data="response.data"
                style="margin:auto;width:calc(100% - 30px)" height="400" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
            <el-table-column label="提现流水号" align="center" prop="id"></el-table-column>
            <el-table-column label="状态" align="center" prop="stateStr"></el-table-column>
            <el-table-column label="提现金额" align="center">
                <template slot-scope="scope">{{ scope.row.withdrawMoney / 100 }}</template>
            </el-table-column>
            <el-table-column label="实际到账金额" align="center">
                <template slot-scope="scope">{{ scope.row.realPayment / 100 }}</template>
            </el-table-column>
            <el-table-column label="提现时间" align="center">
                <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
            </el-table-column>
            </el-table>
        <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
        </el-card>
     </el-dialog>
</template>
<script>
import {getWithdrawByCsId} from '../../../api/accountFunds/bdfunddetail.js'
import { formatDate } from "../../../utils/date";
export default {
    data() {
        return {
            csWithdrawDialog: false,
            response: {data: [], total: 0},
            query: {current: 1, size: 15},
            loading: false,
            id: ''
        }
    },
    methods: {
        init(id){
            this.csWithdrawDialog = true;
            this.id = id;
            getWithdrawByCsId({current: this.query.current,size: this.query.size},id).then(result=>{
                this.response.data = result.data.records;
                this.response.total = result.data.total;
            })
        },
        currenChangeHandle(value){
            this.query.current = value;
            this.init(this.id);
        }
    },
    filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm:ss");
        },
    },
}
</script>
<style scoped>
.el-pagination{
    margin-left: 30%;
}
</style>


// WEBPACK FOOTER //
// src/pages/finance/fundsaccount/bdWithdraws.vue